import { EMPLOYMENT_TYPES } from 'cpool-constants';
import { z } from 'zod';

import { schemaEuropaceAngestellter } from './Angestellter.schema';
import { schemaEuropaceArbeiter } from './Arbeiter.schema';
import { schemaEuropaceArbeitsloser } from './Arbeitsloser.schema';
import { schemaEuropaceBeamter } from './Beamter.schema';
import { schemaEuropaceFreiberufler } from './Freiberufler.schema';
import { schemaEuropaceHausfrau } from './Hausfrau.schema';
import { schemaEuropaceRentner } from './Rentner.schema';
import { schemaEuropaceSelbststaendiger } from './Selbststaendiger.schema';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#beschaeftigung

	{
		"beschaeftigungsart": "ANGESTELLTER" | "ARBEITER" | "ARBEITSLOSER" | "BEAMTER" | "FREIBERUFLER" | "HAUSFRAU" | "RENTNER" | "SELBSTSTAENDIGER",
		"angestellter": Angestellter,
		"arbeiter": Arbeiter,
		"arbeitsloser": Arbeitsloser,
		"beamter": Beamter,
		"freiberufler": Freiberufler,
		"hausfrau": Hausfrau,
		"rentner": Rentner,
		"selbststaendiger": Selbstständiger
	}

	The beschaeftigungsart determines which data is used.
	For example the beschaeftigungsart=ARBEITER means that all data of field arbeiter is used,
	for beschaeftigungsart=BEAMTER the data of field beamter is used. All other fields will be ignored.
	If there is no value for beschaeftigungsart or the corresponding field to a beschaeftigungsart is empty, all data is ignored.

*/

export const schemaEuropaceBeschaeftigung = z.object({
    angestellter: z.optional(schemaEuropaceAngestellter),
    arbeiter: z.optional(schemaEuropaceArbeiter),
    arbeitsloser: z.optional(schemaEuropaceArbeitsloser),
    beamter: z.optional(schemaEuropaceBeamter),
    beschaeftigungsart: z.optional(z.nativeEnum(EMPLOYMENT_TYPES)),
    freiberufler: z.optional(schemaEuropaceFreiberufler),
    hausfrau: z.optional(schemaEuropaceHausfrau),
    rentner: z.optional(schemaEuropaceRentner),
    selbststaendiger: z.optional(schemaEuropaceSelbststaendiger),
});

export type SchemaEuropaceBeschaeftigung = z.infer<typeof schemaEuropaceBeschaeftigung>;
